import React, { useRef } from "react";
import {  Row, Col, Button } from "react-bootstrap";
import Formsy from "formsy-react";
import { useAsyncSetState } from "use-async-setstate";
import { useMutation } from "@apollo/client";
import { getOperationName } from "apollo-utilities";
import "../../style/custom/change-details.scss";
import TextField from "../bootstrap/input";
import Captcha from "../bootstrap/captcha2";
import Modal from "../bootstrap/modal";
import { updateUserMutation, getCurrentUserQuery } from "../logic/user";
import VerificationModal from "./verification";
import { createMobileVerificationMutation } from "../logic/mobile";

export default function ChangeDetails(props) {
  const { onClose, user } = props;
  const [state, setState] = useAsyncSetState({
    processing: false,
    error: "",
  });
  const [mobile, setMobile] = useAsyncSetState(user?.mobileNumber);

  const [data, setData] = useAsyncSetState(null);
  const [showVerification, setVerification] = useAsyncSetState(false);
  const [error, setError] = useAsyncSetState(false);

  const [createMobileVerification] = useMutation(
    createMobileVerificationMutation
  );
  console.log({ user });
  const formRef = useRef(null);
  const [updateUser] = useMutation(updateUserMutation);

  async function handleSubmit(input) {
    await setState((prevState) => ({ ...prevState, processing: true }));
    try {
      console.log({ input });
      await updateUser({
        variables: {
          userId: user.id,
          input: {
            email: input?.email,
            mobileNumber: input?.mobile,
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [getOperationName(getCurrentUserQuery)],
      });

      await setState((prevState) => ({ ...prevState, processing: false }));
      // return onClose();
    } catch (err) {
      return setState((prevState) => ({
        ...prevState,
        processing: false,
        error: err,
      }));
    }
  }

  return (
    <>
      {showVerification && (
        <VerificationModal
          data={data}
          onSubmit={async () => handleSubmit(data)}
          onClose={async () => setVerification(false)}
        />
      )}
      <Modal
        show={!showVerification}
        onClose={async () => onClose()}
      >
        <Formsy
          ref={formRef}
          className="change-user-details-form"
          onValidSubmit={async (input) => {
            await setData(input);
            if (user?.mobileNumber !== input?.mobile) {
              try {
                const result = await createMobileVerification({
                  variables: {
                    captcha: input?.captcha,
                    captchaKey: input?.captchaKey,
                    mobileNumber: input?.mobile,
                  },
                  awaitRefetchQueries: true,
                });
                console.log({ result });
                if (result?.data?.classMethods?.MobileVerification?.createMobileVerification) {
                  return setVerification(true);
                }
                return setState({error: result?.errors[0]?.message || "Invalid Captcha"});
              } catch(err) {
                console.log({err})
                return setState({...state, error: err?.message || "Invalid Captcha"});
              }
            }
            return handleSubmit(input);
          }}
        >
          {state.error && (
            <Row>
              <Col>
                <div className="vw-paper vw-notification error">
                  <i
                    className="fas fa-exclamation-circle"
                  />
                  {state.error}  
                </div>
              </Col>
            </Row>
          )}
          <div className="change-user-details-container">
            <div className="change-user-details-heading">
              <p className="change-user-details-title">{"Change Details"}</p>
            </div>

            <div className="field-row-user-firstname">
              <TextField
                inline
                hideRequiredMark={true}
                name="firstName"
                defaultValue={user.firstName}
                placeholder={"First Name"}
                label={"First Name"}
                disabled
                testid="firstName"
                required
              />
            </div>

            <div className="field-row-user-lastname">
              <TextField
                inline
                hideRequiredMark={true}
                defaultValue={user.lastName}
                label={"Last Name"}
                name="lastName"
                placeholder={"Last Name"}
                testid="lastName"
                disabled
                required
              />
            </div>

            <div className="field-row-user-email">
              <TextField
                inline
                name="email"
                hideRequiredMark={true}
                placeholder={"Email"}
                defaultValue={user.email}
                label={"Email"}
                testid="email"
                required
                validations="isEmail"
                validationErrors={{
                  isEmail: "Enter a valid email",
                }}
                disabled={state.processing}
              />
            </div>

             
            <div className="field-row-user-mobile"> 
              <TextField
                inline
                name="mobile"
                type="number"
                label={"Mobile Number"}
                defaultValue={user.mobileNumber}
                hideRequiredMark={true}
                placeholder="Mobile Number"
                required
                onChange={async (e) => setMobile(e?.target?.value)}
              />
            </div>

            {mobile !== user?.mobileNumber && (
            <div className="field-row-user-captcha">
              <Captcha label="captcha" required inline />
            </div>
            )}

            <div className="change-user-details-actions">
              <div className="change-user-details-buttons">
                <div className="cancel-change-user-detail">
                  <Button
                    variant="black-text"
                    type="button"
                    disabled={state.processing}
                    onClick={(e) => {
                      e.preventDefault();
                      return onClose();
                    }}
                  >
                    {"Cancel"}
                  </Button>
                </div>
                <div className="save-change">
                  <Button
                    className="blue-btn-outline"
                    type="submit"
                    disabled={state.processing}
                    onClick={() => formRef.current.submit()}
                  >
                    {"Update"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Formsy>
      </Modal>
    </>
  );
}
